<div class="panel-card quick-links-card">
  <h3>{{ title() | translate }}</h3>
  <ng-content></ng-content>
</div>

